export const isLoading = (state) => state.autosave.outstandingMutations > 0
